export default __webpack_public_path__ + "static/media/Slider.0841906d.webp";